import { COMMON_PERMISSIONS } from '@/commons/permissoesGrupos';

// Cada tutorial decide se aparece para o usuário (`disponivel` no catálogo)
export default [
    {
        path: '/tutoriais',
        name: 'tutoriais',
        component: () => import('@/modules/tutoriais/views/listas/TutoriaisView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: [...COMMON_PERMISSIONS.TODOS],
            isRotaOrigem: true,
        },
    },
];
